module.exports = __webpack_public_path__ + "static/images/w_person.80bf445.png";